import script from "./RechargeDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./RechargeDetails.vue?vue&type=script&setup=true&lang=js"

import "./RechargeDetails.vue?vue&type=style&index=0&id=5e3201a2&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e3201a2"]])

export default __exports__